import { apiSlice } from "../../../app/apiSlice";
import configUrls from "../../../config/configUrls";
import { DocumentoComentario } from "../../../types/documento/comentario/DocumentoComentario";
import { DocumentoComentarioDTO } from "../../../types/documento/comentario/DocumentoComentarioDTO";
import { DocumentoComentarioList } from "../../../types/documento/comentario/DocumentoComentarioList";


const endpointUrl = configUrls.DOCUMENTO_COMENTARIO_EP;







/**comentarios */


function getDocumentoComentarios({ id, search }: { id: string, search: string }) {

    if (!id) {
        // Se 'documento' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }


    return {
        url: `${endpointUrl}/comentarios/${id}?search=${search}`,
        method: "GET",
    }
}
function addDocumentoComentario(obj: DocumentoComentarioDTO) {
    return {
        url: `${endpointUrl}/comentario`,
        method: "POST",
        body: obj,
    }
}
function deleteDocumentoComentario({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/comentario/${id}`,
        method: "DELETE",
    }
}


function getDocumentoComentario(id: string) {
    if (!id) {
        // Se 'documento' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/comentario/${id}`,
        method: "GET",
    }
}
/** */

export const documentoComentarioApiSlice = apiSlice.injectEndpoints({
    endpoints: ({ query, mutation }) => ({
        getDocumentoComentarios: query<DocumentoComentarioList[], { id: string, search: string }>({
            query: getDocumentoComentarios,
            providesTags: ["DocumentoComentario"],
        }),

        getDocumentoComentario: query<DocumentoComentario, string>({
            query: getDocumentoComentario,
            providesTags: ["DocumentoComentario"],
        }),

        addDocumentoComentario: mutation<void, DocumentoComentarioDTO>({
            query: addDocumentoComentario,
            invalidatesTags: ["DocumentoComentario"],
        }),

        deleteDocumentoComentario: mutation<void, { id: string }>({
            query: deleteDocumentoComentario,
            invalidatesTags: ["DocumentoComentario"]
        }),

    }),
});

export const {
    useAddDocumentoComentarioMutation,
    useGetDocumentoComentarioQuery,
    useGetDocumentoComentariosQuery,
    useDeleteDocumentoComentarioMutation,
} = documentoComentarioApiSlice